import { type SessionStore } from '@halo/chat-sdk-react';
import { ChatPanelHeaderActions } from '@halo/ui-chat-react';
// import { MsgPayloadType } from '@halo/chat-sdk';
// import type { Session } from '@halo/chat-sdk-react';
// import { useAppStore, WsStatus } from '@/store/client';

export interface ChatContentHeaderActionsProps {
  isGroupError: boolean;
  sessionStore?: SessionStore;
  isGroup: boolean;
  isMe: boolean;
  isCalling: boolean;
  onMediaClick: (key: any) => void;
  onSettingClick: () => void;
}

export const ChatContentHeaderActions = memo(function ChatContentHeaderActions({
  isGroupError,
  isGroup,
  isMe,
  isCalling,
  // sessionStore,
  onMediaClick,
  onSettingClick,
}: ChatContentHeaderActionsProps) {
  // const { user, wsStatus } = useAppStore();

  // const membersNoMe = useMemo(() => {
  //   if (isGroup) {
  //     return sessionStore?.members?.filter((item) => item?.user_id !== user?.user_id) || [];
  //   }
  //   return [];
  // }, [user?.user_id, sessionStore?.members, isGroup]);

  // const online = useMemo(() => {
  //   return wsStatus === WsStatus.Open;
  // }, [wsStatus]);

  // const onMediaClick = useCallback(
  //   (key: MsgPayloadType | string) => {
  //     switch (key) {
  //       case 'select-members':
  //         setGroupCreateCallIsOpen(true, {
  //           title: 'Select Members',
  //           list: [
  //             {
  //               label: null,
  //               items: membersNoMe || [],
  //             },
  //           ],
  //         });
  //         break;
  //       case MsgPayloadType.MEDIA_AUDIO_CALL:
  //       case MsgPayloadType.MEDIA_VIDEO_CALL:
  //         if (!online) {
  //           toaster.error({
  //             title: 'Network error.',
  //           });
  //           return;
  //         }
  //         if (isGroup) {
  //           //TODO
  //         }
  //         break;
  //     }
  //     console.log('onMediaClick', key);
  //   },
  //   [setGroupCreateCallIsOpen, membersNoMe, online, isGroup]
  // );

  if (isGroupError) {
    return null;
  }

  return (
    <ChatPanelHeaderActions
      isGroup={isGroup}
      isMe={isMe}
      isCalling={isCalling}
      onMediaClick={onMediaClick}
      onSettingClick={onSettingClick}
    />
  );
});
